/* moose.lighting homepage hero
   Each visitor gets the banners in a different order.

   The theme puts its own image back twice: once when a slide lazy-loads,
   and again every time a slide becomes the active one. A one-off swap
   therefore survives the page load and then loses the moment you click an
   arrow. So each image is assigned a banner once, remembered on the element,
   and a MutationObserver puts it back for as long as the page is open.
   If anything here fails the slider keeps whatever the theme editor set. */
(function () {
  "use strict";
  var IMAGES = [
  "https://cdn.shopify.com/s/files/1/0076/2350/8020/files/hero-5-dining-gold-discs.jpg?v=1789091051",
  "https://cdn.shopify.com/s/files/1/0076/2350/8020/files/hero-4-green-sofa-lotus.jpg?v=1789091053",
  "https://cdn.shopify.com/s/files/1/0076/2350/8020/files/hero-3-kitchen-firefly.jpg?v=1789091056",
  "https://cdn.shopify.com/s/files/1/0076/2350/8020/files/hero-1-bedroom-chandelier.jpg?v=1789091058",
  "https://cdn.shopify.com/s/files/1/0076/2350/8020/files/hero-2-coastal-entry.jpg?v=1789091060"
];
  var COPY = "More than illumination. The right fixture is the fastest way to say something about how you live. From pendants to chandeliers to wall sconces, we source authentic designs that make a room brighter and unmistakably yours.";
  var BTN_TEXT = "Shop All Lighting";
  var BTN_HREF = "/collections/all";
  var pick = null;
  var writing = false;
  var observer = null;

  function shuffled(a) {
    var b = a.slice();
    for (var i = b.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = b[i]; b[i] = b[j]; b[j] = t;
    }
    return b;
  }

  /* The theme lazy-loads from data-srcset, so set every attribute it reads,
     not just src, and drop the lazy classes. */
  function setImage(img, src) {
    if (!img || !src) { return; }
    writing = true;
    img.classList.remove('lazy');
    img.classList.remove('lazyload');
    img.classList.remove('lazyloading');
    img.removeAttribute('sizes');
    img.removeAttribute('data-sizes');
    img.setAttribute('data-moose-hero', src);
    img.setAttribute('src', src);
    img.setAttribute('srcset', src);
    img.setAttribute('data-src', src);
    img.setAttribute('data-srcset', src);
    writing = false;
  }

  /* Put our banner back if anything swaps it out. */
  function enforce(img) {
    var want = img.getAttribute('data-moose-hero');
    if (!want) { return; }
    if (img.getAttribute('src') === want && img.getAttribute('srcset') === want) { return; }
    setImage(img, want);
  }

  function watch(root) {
    if (observer || !window.MutationObserver) { return; }
    observer = new MutationObserver(function (records) {
      if (writing) { return; }
      var repaint = false;
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes' && r.target && r.target.tagName === 'IMG') {
          enforce(r.target);
        } else if (r.type === 'childList' && r.addedNodes.length) {
          repaint = true;
        }
      }
      if (repaint) { paint(); }
    });
    observer.observe(root, {
      subtree: true, childList: true,
      attributes: true, attributeFilter: ['src', 'srcset', 'class']
    });
  }

  function paint() {
    var root = document.querySelector('.slider__slick');
    if (!root) { return false; }
    var slides = [].slice.call(root.querySelectorAll('.slick-slide'));
    if (!slides.length) { slides = [].slice.call(root.querySelectorAll('.promobox')); }
    if (!slides.length) { return false; }
    if (!pick) { pick = shuffled(IMAGES); }

    slides.forEach(function (slide, n) {
      var raw = slide.getAttribute('data-slick-index');
      var idx = raw === null ? n : parseInt(raw, 10);
      if (isNaN(idx)) { idx = n; }
      var fallback = pick[((idx % pick.length) + pick.length) % pick.length];

      [].slice.call(slide.querySelectorAll('img')).forEach(function (img) {
        /* keep an image on the banner it was first given, so slick
           renumbering its slides cannot reshuffle them mid-view */
        var already = img.getAttribute('data-moose-hero');
        setImage(img, already || fallback);
      });

      var head = slide.querySelector('.promobox__text-2');
      if (head && head.textContent !== COPY) { head.textContent = COPY; }
      var sub = slide.querySelector('.promobox__text-3');
      if (sub && sub.textContent) { sub.textContent = ''; }
      var btn = slide.querySelector('.promobox__btn-1');
      if (btn && btn.getAttribute('data-moose-hero') === null) {
        btn.textContent = BTN_TEXT;
        btn.setAttribute('href', BTN_HREF);
        btn.setAttribute('data-moose-hero', '1');
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '&rarr;';
        btn.appendChild(arrow);
      }
    });

    root.classList.add('moose-hero-ready');
    watch(root);
    return true;
  }

  function go() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (paint() || tries > 20) { clearInterval(t); }
    }, 250);
    if (window.jQuery) {
      try {
        window.jQuery(document).on('afterChange beforeChange setPosition init',
          '.slider__slick', function () { paint(); });
      } catch (e) {}
    }
  }

  if (document.readyState === 'complete') { go(); }
  else { window.addEventListener('load', go); }
})();
